import { useMemo } from "react";
import TableContainer from "../../../../common/table/TableContainer";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import load from "../../../../assets/images/load-img.png";
import "../../utils/history.css";
import { useQuery } from "react-query";
import { getPaymentByBusinessId } from "../../../payements/services/paymentApi";
import { getDetailCountryPerMerchant } from "../../services/versementApi";
import FormatDate from "../../../../common/format/formatDate";

const ReversementsHistoryCC = ({selectedBusiness, countryCode}) => {

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const merchandId = Number(currentUser?.user?.id) || Number(currentUser?.user?.merchantId);
  const busId = Number(selectedBusiness?.id); 

  const props = {
    token : currentUser?.token,
    merchandId: merchandId,
    countryCode: countryCode,    
  }
  const { data: reversement, isLoading, isError, error } = useQuery(
    ["reversements", merchandId, busId],
    () => {
      if (busId) {
        return getPaymentByBusinessId(busId);
      } else {
        return getDetailCountryPerMerchant(props);
      }
    },
    {
      enabled: !!busId || !!merchandId,
    }
  );
  
  const columns = useMemo(() => [
    { Header: "Business", accessor: "developerAccountName", filterable: false },
    {
      Header: "Montant recu",
      accessor: "amount",
      Cell: ({ row }) => {
        const amount = row.original.amount;
        const currency = row.original.currency || "XOF";
        return `${amount.toLocaleString()} ${currency}`;
      },
      filterable: false,
    },   
    {
      Header: "Montant débité",
      accessor: "realAmount",
      Cell: ({ row }) => {
        const amount = row.original.realAmount;
        const currency = row.original.currency || "XOF";
        return `${amount.toLocaleString()} ${currency}`;
      },
      filterable: false,
    },
    {
      Header: "Versé le",
      accessor: "createdAt",
      Cell: ({ value }) => <FormatDate date={value} showTime />,
      filterable: false,
    },
    {
      Header: "Statut",
      accessor: "status",
      Cell: ({ value }) => {
        let backgroundColor = "";
        let textColor = "";
        let icon = null;
        let label = "";

        switch (value) {
          case "SUCCESS":
            backgroundColor = "#EBFFEA";
            textColor = "#349C32";
            icon = <CheckOutlined style={{ color: textColor, marginRight: 6 }} />;
            label = "Réussie";
            break;
          case "PENDING":
            backgroundColor = "#F6F6F6";
            textColor = "#FF9F00";
            icon = <img src={load}/>;
            label = "En attente";
            break;
          default:
            backgroundColor = "#FFF2F2";
            textColor = "#E00909";
            icon = <CloseOutlined style={{ color: textColor, marginRight: 6 }} />;
            label = "Échec";
            break;
        }

        return (
          <span
            style={{
              backgroundColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "20px",
              display: "inline-flex",
              alignItems: "center",
              fontWeight: 500,
              fontSize: 13,
            }}
          >
            {icon}
            {label}
          </span>
        );
      },
      filterable: false,
    },
  ]);

  return (
      <div className="page-content">
        <div className="title-page-country mt-2 mb-3">
          Historique des versements
        </div>
        <TableContainer
          columns={columns}
          data={reversement?.data || []}
          isGlobalSearch={true}
          isGlobalFilter={true}
          customPageSize={5}
          className="custom-header-css"
          divClass="table-responsive table-card mb-3"
          tableClass="align-middle table-nowrap"
          theadClass="table-light"
          SearchPlaceholder="Recherche..."
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      </div>
  );
};

export default ReversementsHistoryCC;
